import { CardsContainer } from "../Dashboard.cards/Cards.styled";

const WWPRNocTab = () => {
  return (
    <>
      <CardsContainer style={{ padding: "5px 20px" }}></CardsContainer>
    </>
  );
};

export default WWPRNocTab;
